import { render, staticRenderFns } from "./BetslipTicket.vue?vue&type=template&id=aaa8f304&scoped=true"
import script from "./BetslipTicket.vue?vue&type=script&lang=js"
export * from "./BetslipTicket.vue?vue&type=script&lang=js"
import style0 from "./BetslipTicket.vue?vue&type=style&index=0&id=aaa8f304&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aaa8f304",
  null
  
)

export default component.exports